import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { PageMeta } from '../../components/meta/PageMeta';
import { useGetAllPagesQuery } from '../../services/endpoints/website/page';
import { GetQueryParams } from '../../types/api.type';
import { Page } from '../../types/website.types';
import { BlogCard } from './BlogCard';
import StickyNotesPagination from './StickyNotesPagination';
import './StickyNotes.css';

const defaultScope = 'featured';
const ENTRIES_PER_PAGE = 9;

export const StickyNotesSection = () => {
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [filters, setFilters] = useState<GetQueryParams>({
    scope: defaultScope,
    data: {
      page: 1,
      entries: ENTRIES_PER_PAGE,
      orderBy: { field: 'published_on', order: 'desc' }
    }
  });
  const [pages, setPages] = useState<Page[]>([]);
  const { data, error, isLoading, isFetching } = useGetAllPagesQuery(filters);

  useEffect(() => {
    if (data && data?.results) {
      setPages(data.results);
    }
    if (data?.count != null) {
      setCount(data.count);
    }
  }, [data]);

  const handlePageClick = (nextPage: number) => {
    setPage(nextPage);
    setFilters((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        page: nextPage
      }
    }));
  };

  return (
    <div id="sticky-notes">
      <PageMeta
        title="Sticky Notes - Blog"
        description="Discover deliciously fun tidbits, awesome activities & the latest dish on Sticky Notes — the Sticky Fingers Cooking blog. New kid-friendly content every week!"
      />
      <div className="w-100 header-image-sticky-notes">
        <h1 className="text-weight-700">Sticky Notes</h1>
        <div className="text-weight-700">
          <strong>
            Discover deliciously fun tidbits, awesome activities &amp; the latest dish!
          </strong>
        </div>
      </div>

      <Container
        fluid
        className="text-blue mt-5 bg-white"
      >
        <Container className="pb-5">
          <div className="div-blog-grid">
            <div className="w-layout-grid blog-grid">
              {pages.map((p) => (
                <BlogCard
                  key={p.id}
                  page={p}
                />
              ))}
            </div>
          </div>
          <StickyNotesPagination
            page={page}
            count={count}
            onPageClick={handlePageClick}
          />
        </Container>
      </Container>
    </div>
  );
};
